import React, { useState, useEffect, useRef, useMemo } from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { MapContainer, TileLayer, Marker, Popup, useMap, Polyline, Circle, FeatureGroup, GeoJSON } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import ReactDOMServer from 'react-dom/server';

// Importación EXPLÍCITA del plugin (¡crítico!)
import 'leaflet-draw';
import axios from 'axios';
import L from 'leaflet';
import { Clock, MapPin, Truck, Calendar, Package, User, Eye, AlertTriangle, Warehouse, IdCard, RectangleHorizontal, MapPinIcon, MessageSquarePlus } from 'lucide-react';
import ModalIncidencias from '../components/acciones/ModalIncidencias';
import MarkerClusterGroup from 'react-leaflet-cluster';
import { EditControl } from 'react-leaflet-draw';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { MultiSelect } from 'primereact/multiselect';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { Calendar as CalendarPrime } from 'primereact/calendar';
import { FloatLabel } from 'primereact/floatlabel';
import { addLocale } from 'primereact/api';

import FeatureDialog from '../components/ActiveShipments/FeatureDialog';
import { Toast } from 'primereact/toast';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Autocomplete,
  Checkbox,
} from '@mui/material';
import GeocercasService from '../services/GeocercasService';
import TransportistasService from '../services/TransportistasService';
import NotificationPhoneService from '../services/NotificationPhoneService';
import "../css/ActiveShipments.css";

import greenPin from '../assets/green_pin.png';
import redPin from '../assets/red_pin.png';
import yellowPin from '../assets/yellow_pin.png';


// This component updates the map when the center changes
const STORAGE_KEY = 'leaflet-draw-features';

// Solución para iconos faltantes en Leaflet
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
//   iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
//   shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
// });

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ActiveShipments = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeItem, setActiveItem] = useState('activeShipments');
  const [shipments, setShipments] = useState([]);
  // const [filteredShipments, setFilteredShipments] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [mapCenter, setMapCenter] = useState([19.4326, -99.1332]); // Default to Mexico City
  const [searchValue, setSearchValue] = useState('');

  // State for tracking selection
  const [selectedShipments, setSelectedShipments] = useState({});
  const [activeTracking, setActiveTracking] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const mapRef = useRef();

  // New state for incident modal
  const [isIncidentModalOpen, setIsIncidentModalOpen] = useState(false);
  const [selectedShipmentForIncident, setSelectedShipmentForIncident] = useState(null);

  const [map, setMap] = useState(null);
  const [featuresGeofences, setFeaturesGeofences] = useState([]);
  const featureGroupRef = useRef();
  const position = [51.505, -0.09];
  const [wsGeocercaShipment, setWsGeocercaShipment] = useState(null);
  const wsShipmentLastUbication = useRef(null);

  const [wsMonitoringShipment, setWsMonitoringShipment] = useState(null);

  const [geometrySelected, setGeometrySelected] = useState([]);
  const [locationSelected, setLocationSelected] = useState([]);

  const [filters, setFilters] = useState({
    reference: "",
    truck: "",
    status: [],
    substatus: [],
    pickupDate: { from: "", to: "" },
    orderAppointmentDate: { from: "", to: "" },
    vendor: ""
  });

  const [status, setStatus] = useState(null);
  const [substatus, setSubstatus] = useState(null);
  const [dates, setDates] = useState(null);

  const [dates2, setDates2] = useState(null);
  const [cuentas, setCuentas] = useState([]);
  const [operadores, setOperadores] = useState([]);
  const [clients, setClients] = useState([]);
  const toast = useRef(null);
  const toastTopCenter = useRef(null);

  const cities = [
    { name: 'New York', code: 'NY' },
    { name: 'Rome', code: 'RM' },
    { name: 'London', code: 'LDN' },
    { name: 'Istanbul', code: 'IST' },
    { name: 'Paris', code: 'PRS' }
  ];


  const [optionsReference, setOptionsReference] = useState([]);
  const [optionsTruck, setOptionsTruck] = useState([]);
  const [optionsStatus, setOptionsStatus] = useState([]);
  const [optionsSubStatus, setOptionsSubtatus] = useState([]);

  const [sendingNotification, setSendingNotification] = useState(false);

  addLocale('es', {
    firstDayOfWeek: 1,
    showMonthAfterYear: true,
    dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
    monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
    today: 'Hoy',
    clear: 'Limpiar'
  });

  // Function to open incident modal
  const handleOpenIncidentModal = (shipment) => {
    setSelectedShipmentForIncident(shipment);
    setIsIncidentModalOpen(true);
  };

  // Function to close incident modal
  const handleCloseIncidentModal = () => {
    setSelectedShipmentForIncident(null);
    setIsIncidentModalOpen(false);
  };


  const trayectos = [
    [
      { lat: 20.6597, lng: -103.3496, timestamp: '2025-04-23 08:00' },
      { lat: 20.6600, lng: -103.3500, timestamp: '2025-04-23 08:01' },
      { lat: 20.6605, lng: -103.3510, timestamp: '2025-04-23 08:02' },
      { lat: 20.6610, lng: -103.3520, timestamp: '2025-04-23 08:03' },
      { lat: 20.6615, lng: -103.3530, timestamp: '2025-04-23 08:04' },
    ],
    [
      { lat: 20.6620, lng: -103.3540, timestamp: '2025-04-23 08:05' },
      { lat: 20.6625, lng: -103.3550, timestamp: '2025-04-23 08:06' },
      { lat: 20.6630, lng: -103.3560, timestamp: '2025-04-23 08:07' },
      { lat: 20.6635, lng: -103.3570, timestamp: '2025-04-23 08:08' },
      { lat: 20.6640, lng: -103.3580, timestamp: '2025-04-23 08:09' },
    ],
    [
      { lat: 20.6760, lng: -103.3470, timestamp: '2025-04-23 08:10' },
      { lat: 20.6770, lng: -103.3480, timestamp: '2025-04-23 08:11' },
      { lat: 20.6780, lng: -103.3490, timestamp: '2025-04-23 08:12' },
      { lat: 20.6790, lng: -103.3500, timestamp: '2025-04-23 08:13' },
      { lat: 20.6800, lng: -103.3510, timestamp: '2025-04-23 08:14' },
    ],
    [
      { lat: 24.0277, lng: -104.6530, timestamp: '2025-04-23 08:15' },
      { lat: 24.0282, lng: -104.6540, timestamp: '2025-04-23 08:16' },
      { lat: 24.0287, lng: -104.6550, timestamp: '2025-04-23 08:17' },
      { lat: 24.0292, lng: -104.6560, timestamp: '2025-04-23 08:18' },
      { lat: 24.0297, lng: -104.6570, timestamp: '2025-04-23 08:19' },
    ],
    [
      { lat: 20.6597, lng: -103.3496, timestamp: '2025-04-23 08:00' }, // Guadalajara
      { lat: 20.8032, lng: -102.7586, timestamp: '2025-04-23 09:00' }, // Tepatitlán
      { lat: 21.3563, lng: -101.9330, timestamp: '2025-04-23 10:00' }, // Lagos de Moreno
      { lat: 21.8853, lng: -102.2916, timestamp: '2025-04-23 11:00' }, // Aguascalientes
      { lat: 22.7709, lng: -102.5832, timestamp: '2025-04-23 12:00' }, // Zacatecas
      { lat: 23.1750, lng: -102.8670, timestamp: '2025-04-23 13:00' }, // Fresnillo
      { lat: 24.0477, lng: -104.6530, timestamp: '2025-04-23 14:00' }, // Durango
    ]
  ];

  const [openDialog, setOpenDialog] = useState(false);
  const [pendingLayer, setPendingLayer] = useState(null);
  const [featureName, setFeatureName] = useState('');
  const [isLoadingPage, setIsLoadingPage] = useState(true);




  const [trayectosSeleccionados, setTrayectosSeleccionados] = useState([]);
  const [popupAbiertoIdx, setPopupAbiertoIdx] = useState(null);

  const generateMultipleTrackingPoints = (numTrips = 40, totalPoints = 600, startLat = 20.661, startLng = -103.352) => {
    const allTrips = [];

    // Generar múltiples trayectos
    for (let trip = 0; trip < numTrips; trip++) {
      const tripPoints = [];
      const startTime = new Date('2025-04-24T08:00:00');

      for (let i = 0; i < totalPoints; i++) {
        // Modificar el lat y lng para cada trayecto, cambiando un poco la posición inicial de cada uno
        const lat = startLat + Math.random() * 0.01 + (trip * 0.002); // Cambiar latitudes levemente para cada viaje
        const lng = startLng + Math.sin(i / 50) * 0.001 + (trip * 0.002); // Cambiar longitudes levemente para cada viaje
        const timestamp = new Date(startTime.getTime() + i * 30000).toISOString().slice(0, 19).replace('T', ' ');

        tripPoints.push({ lat, lng, timestamp });

      }


      allTrips.push(tripPoints);
    }

    return allTrips;
  };

  const filteredShipments = useMemo(() => {
    const filtered = shipments.filter(s => {

      if (filters.reference && !s.reference.includes(filters.reference)) return false;
      if (filters.truck && !s.Truck.includes(filters.truck)) return false;
      if (filters.status.length && !filters.status.includes(s.status)) return false;
      if (filters.substatus.length && !filters.substatus.includes(s.Substatus)) return false;

      if (filters.pickupDate.from) {
        if (new Date(s.pickup_date) < new Date(filters.pickupDate.from)) return false;
      }
      if (filters.pickupDate.to) {
        const toDate = new Date(filters.pickupDate.to);
        toDate.setHours(23, 59, 59, 999);
        if (new Date(s.pickup_date) > toDate) return false;
      }



      const appointmentDateString =
        Array.isArray(s.orders) && s.orders.length > 0
          ? s.orders[0].Appointment
          : null;

      const appointmentTimeString =
        Array.isArray(s.orders) && s.orders.length > 0
          ? s.orders[0].Appointment_hr
          : null;

      if (filters.orderAppointmentDate.from || filters.orderAppointmentDate.to) {
        // Excluir si no hay fecha o hora de cita
        if (!appointmentDateString || !appointmentTimeString) return false;

        // Combinar fecha y hora en formato ISO 8601
        const appointmentDateTimeString = `${appointmentDateString}T${appointmentTimeString}`;
        const dateAppt = new Date(appointmentDateTimeString);

        const from = filters.orderAppointmentDate.from
          ? new Date(filters.orderAppointmentDate.from)
          : null;
        const to = filters.orderAppointmentDate.to
          ? new Date(filters.orderAppointmentDate.to)
          : null;

        // Normalizar la hora a medianoche para comparar solo la fecha
        dateAppt.setHours(0, 0, 0, 0);
        if (from) from.setHours(0, 0, 0, 0);
        if (to) to.setHours(23, 59, 59, 999);

        if (from && dateAppt < from) return false;
        if (to && dateAppt > to) return false;
      }




      if (filters.vendor && filters.vendor.length > 0) {
        // Utiliza some() para verificar si alguno de los objetos en filters.vendor tiene un nombre_cuenta que coincida con s.vendor
        if (!filters.vendor.some(v => v.nombre_cuenta === s.vendor)) {
          return false;
        }
      }

      return true;
    });


    const sel = [];
    const noSel = [];
    filtered.forEach(s =>
      trayectosSeleccionados.includes(s.id) ? sel.push(s) : noSel.push(s)
    );

    return [...sel, ...noSel];
  }, [shipments, filters, trayectosSeleccionados]);

  const filteredIds = filteredShipments.map(s => s.id);

  useEffect(() => {


    const nuevaSeleccion = trayectosSeleccionados.filter(id =>
      filteredIds.includes(id)
    );

    if (nuevaSeleccion.length != 1 && geometrySelected.length !== 0) { //geometrySelected.length !== 0 prevent error
      setGeometrySelected([])
      setLocationSelected([])


      const allPoints = shipments
        .filter(s => {
          const hasValidCoords = s.last_latitude !== 0 && s.last_longitude !== 0;
          return hasValidCoords;
        });

      if (mapRef.current && allPoints.length > 0) {
        const bounds = L.latLngBounds(allPoints.map(p => [p.last_latitude, p.last_longitude]));
        mapRef.current.fitBounds(bounds, {
          padding: [50, 50],
          maxZoom: 15,
        });
      }


    }


    if (nuevaSeleccion.length !== trayectosSeleccionados.length) {
      setTrayectosSeleccionados(nuevaSeleccion);
    }
  }, [filteredIds, trayectosSeleccionados]);

  const redIcon = new L.Icon({
    iconUrl: redPin,
    shadowSize: [41, 41],

    iconSize: [32, 32],
    iconAnchor: [16, 30],          // centro del icono
    popupAnchor: [0, 10],        // desplaza el popup 12px hacia arriba
  });

  const greenIcon = new L.Icon({
    iconUrl: greenPin,
    shadowSize: [41, 41],

    iconSize: [34, 34],
    iconAnchor: [16, 30],         // centro del icono
    popupAnchor: [0, 10],        // desplaza el popup 12px hacia arriba
  });

  const yellowIcon = new L.Icon({
    iconUrl: yellowPin,
    shadowSize: [41, 41],

    iconSize: [32, 32],
    iconAnchor: [16, 30],          // centro del icono
    popupAnchor: [0, 10],        // desplaza el popup 12px hacia arriba
  });

  const CustomMarker = ({ punto, shipment, isSelected }) => {
    const markerRef = useRef(null);

    // if (isSelected && markerRef.current) {
    //   markerRef.current.openPopup();
    // }


    return (
      <Marker
        position={[punto.lat, punto.lng]}
        ref={markerRef}
        icon={
          shipment.isInactive ? redIcon :
            shipment.isStationary ? yellowIcon :
              greenIcon
        }
        options={{ isInactive: shipment.isInactive }}
      >
        <Popup offset={L.point(0, -30)}>
          <div>
            <strong>Última posición</strong><br />
            <strong>Referencia:</strong> {shipment.reference}<br />
            <strong>Lat:</strong> {punto.lat.toFixed(5)}<br />
            <strong>Lng:</strong> {punto.lng.toFixed(5)}<br />
            {shipment.last_timestamp && (
              <><strong>fecha:</strong> {formatDate(shipment.last_timestamp)}<br /></>
            )}

            {shipment.last_battery_level && (
              <>
                <strong>Batería:</strong> {shipment.last_battery_level}<br />
              </>
            )}

            {shipment.last_speed && (
              <>
                <strong>Velocidad:</strong> {Math.trunc(shipment.last_speed)}<br />
              </>
            )}

          </div>
        </Popup>
      </Marker>
    );
  };


  const conectarWebSocketGeocercaShipment = (idviajeSeleccionado) => {
    const roomId = `salaGeocerca_${idviajeSeleccionado}`;
    const ws = new WebSocket(`${process.env.REACT_APP_WEB_SOCKET_URL}/${roomId}`);
    setWsGeocercaShipment(ws);

    // ws.onopen = () => {
    //   console.log(`Conectado a la sala: ${roomId}`);
    // };
    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log("Mensaje recibido:", data);
      if (data.action === "create") {

        const { type, geojson } = data.data;        // type = 'circle'|'rectangle'|'polygon'

        // Reconstruir la capa definitiva según el tipo que devolvió la API
        let finalLayer;

        if (type === "circle" && geojson.properties?.radius) {
          const coords = geojson.geometry.coordinates;
          const latlng = [coords[1], coords[0]];
          finalLayer = L.circle(latlng, {
            radius: geojson.properties.radius,
          });

          finalLayer.feature = geojson;

        } else if (type === "rectangle") {
          const coords = geojson.geometry.coordinates?.[0];
          const bounds = [
            [coords[0][1], coords[0][0]],
            [coords[2][1], coords[2][0]],
          ];
          finalLayer = L.rectangle(bounds);

          finalLayer.feature = geojson;

        } else {
          finalLayer = L.geoJSON(geojson).getLayers()[0];
        }

        const name = geojson.properties?.name;
        if (name) {
          finalLayer.bindPopup(`<strong>${name}</strong>`);
        }

        featureGroupRef.current.addLayer(finalLayer);

      } else if (data.action === "delete") {
        const { id_geocerca } = data;
        if (featureGroupRef.current) {
          featureGroupRef.current.eachLayer(layer => {
            if (layer.feature?.properties?.id_geocercas === id_geocerca) {
              featureGroupRef.current.removeLayer(layer);
            }
          });
        }

      } else if (data.action === "update") {
        const { id_geocerca, id_shipment } = data;
        const { type, geojson } = data.data;

        if (featureGroupRef.current) {

          featureGroupRef.current.eachLayer(layer => {
            if (layer.feature?.properties?.id_geocercas === id_geocerca) {
              // Actualizar la geometría de la capa existente
              if (!layer || !geojson) return;

              // Actualizar geometría según el tipo
              try {
                switch (type) {
                  case 'circle':
                    if (geojson.properties?.radius) {
                      const coords = geojson.geometry.coordinates;
                      const latlng = [coords[1], coords[0]];
                      if (layer.setLatLng) layer.setLatLng(latlng);
                      if (layer.setRadius) layer.setRadius(geojson.properties.radius);
                    }
                    break;

                  case 'rectangle':
                    const coords = geojson.geometry.coordinates?.[0];
                    if (coords && coords.length >= 4) {
                      const bounds = [
                        [coords[0][1], coords[0][0]],
                        [coords[2][1], coords[2][0]]
                      ];
                      if (layer.setBounds) layer.setBounds(bounds);
                    }
                    break;

                  case 'polygon':
                  case 'polyline':
                    const latLngs = geojson.geometry.coordinates.map(coord =>
                      Array.isArray(coord[0])
                        ? coord.map(c => [c[1], c[0]]) // Para polígonos
                        : [coord[1], coord[0]] // Para líneas
                    );
                    if (layer.setLatLngs) layer.setLatLngs(latLngs);
                    break;

                  default:
                    console.warn(`Tipo de geometría no soportado: ${type}`);
                    break;
                }
              } catch (error) {
                console.error('Error al actualizar la capa:', error);
              }
            }

          });
        }

      }
      // aquí procesas la geocerca actualizada…
    };
    ws.onerror = (error) => console.error("WebSocket error:", error);
    ws.onclose = (ev) => {
      console.log(`Desconectado de ${roomId}`, ev.reason);
    };


  };

  const desconectarWebSocketGeocercaShipment = () => {
    if (wsGeocercaShipment) {
      wsGeocercaShipment.close(1000, "Usuario deseleccionó el viaje");
      setWsGeocercaShipment(null);
    }
  };

  const conectarWebSocketMonitoringShipment = (id_shipment) => {
    const roomId = `salaMonitoringShipment_${id_shipment}`;
    const ws = new WebSocket(`${process.env.REACT_APP_WEB_SOCKET_URL}/${roomId}`);
    setWsMonitoringShipment(ws);

    // ws.onopen = () => {
    //   console.log(`Conectado a la sala: ${roomId}`);
    // };
    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log("Mensaje recibido:", data);
      if (data.action === "update_geometries") {
        let newGeometries = data.data;


        setGeometrySelected(prev => [...prev, ...newGeometries]);

      }
      if (data.action === "update_locations") {
        let newLocations = data.data;


        setLocationSelected(prev => [...prev, ...newLocations]);

      }
    };
    ws.onerror = (error) => console.error("WebSocket error:", error);
    ws.onclose = (ev) => {
      console.log(`Desconectado de ${roomId}`, ev.reason);
    };


  };

  const desconectarWebSocketMonitoringShipment = () => {
    if (wsMonitoringShipment) {
      wsMonitoringShipment.close(1000, "Usuario deseleccionó el viaje");
      setWsMonitoringShipment(null);
    }
  };


  const handleClickSelectedTrayecto = (ship) => {

    const id = ship.id;
    const isSelected = trayectosSeleccionados.includes(id);
    const newSelection = isSelected
      ? trayectosSeleccionados.filter(i => i !== id)
      : [...trayectosSeleccionados, id];

    setTrayectosSeleccionados(newSelection);

    // Esperamos un pequeño tiempo para asegurar que se actualiza el mapa luego del render
    setTimeout(async () => {
      // Ordenamos los elementos basados en si están seleccionados o no
      // const sortedShipments = [...shipments].sort((a, b) => {
      //   const aSelected = newSelection.includes(a.id);
      //   const bSelected = newSelection.includes(b.id);
      //   return aSelected === bSelected ? 0 : aSelected ? -1 : 1;
      // });

      // // Actualizamos el estado de los "filtered" con los trayectos ordenados
      // setFilteredShipments(sortedShipments);

      if (newSelection.length === 1) {//si solo es 1 item seleccionado

        const selected = shipments.find(ship => ship.id == newSelection[0]);
        if (selected && selected.last_latitude !== 0) {

          // conectarWebSocketMonitoringShipment(newSelection)
          let dataTrackingDetail = { id_shipment: newSelection[0] }
          const responseTracking = await TransportistasService.postMonitoringTrackingDetail(dataTrackingDetail)
          if (responseTracking.data.status && responseTracking.data.status == 200) {
            const { geometry, locations } = responseTracking.data.data;


            setGeometrySelected(geometry)
            setLocationSelected(locations)
            handleSelectShipment(selected);
            conectarWebSocketMonitoringShipment(newSelection[0])

          }
        }
        const response = await GeocercasService.getGeocercaShipmentById(newSelection)
        if (response.data.status && response.data.status == 200) {

          const responseGetGeocercas = await GeocercasService.getGeocercas();

          if (responseGetGeocercas.status && responseGetGeocercas.status == 200) {
            let allGeocercas = responseGetGeocercas.data.data;
            setFeaturesGeofences(allGeocercas)
          }

          const poligonos = response.data.data;

          if (featureGroupRef.current) {
            poligonos.forEach((f) => {
              let layer;

              if (f.type === "circle" && f.geojson.properties?.radius) {
                const coords = f.geojson.geometry.coordinates;
                const latlng = [coords[1], coords[0]];
                layer = L.circle(latlng, {
                  radius: f.geojson.properties.radius,
                });

                layer.feature = f.geojson;

              } else if (f.type === "rectangle") {
                const coords = f.geojson.geometry.coordinates?.[0];
                const bounds = [
                  [coords[0][1], coords[0][0]],
                  [coords[2][1], coords[2][0]],
                ];
                layer = L.rectangle(bounds);

                layer.feature = f.geojson;

              } else {
                layer = L.geoJSON(f.geojson).getLayers()[0];
              }

              const name = f.geojson.properties?.name;
              if (name) {
                layer.bindPopup(`<strong>${name}</strong>`);
              }

              featureGroupRef.current.addLayer(layer);
            });
          }

          conectarWebSocketGeocercaShipment(newSelection[0])
        }

      } else if (newSelection.length == 0) {
        desconectarWebSocketGeocercaShipment();
        clearAllFeatures();
        desconectarWebSocketMonitoringShipment();
        setGeometrySelected([])
        setLocationSelected([])

      } else if (newSelection.length > 1) {
        desconectarWebSocketGeocercaShipment();
        clearAllFeatures();
        desconectarWebSocketMonitoringShipment();
        setGeometrySelected([])
        setLocationSelected([])

        const allPoints = shipments
          .filter(s => {
            const included = newSelection.includes(s.id);
            const hasValidCoords = s.last_latitude !== 0 && s.last_longitude !== 0;
            return included && hasValidCoords;
          });


        if (mapRef.current && allPoints.length > 0) {
          const bounds = L.latLngBounds(allPoints.map(p => [p.last_latitude, p.last_longitude]));
          mapRef.current.fitBounds(bounds, {
            padding: [50, 50],
            maxZoom: 15,
          });
        }
      }
    }, 0); // ⏱️ usamos `setTimeout(..., 0)` para ejecutar después del render
  };



  const isChecked = (id_shipment) => {
    // console.log(id_shipment);
    return trayectosSeleccionados.includes(id_shipment);

  };

  const handleSelectShipment = (tracking) => {
    if (mapRef.current) {
      const bounds = [[tracking.last_latitude, tracking.last_longitude]];
      mapRef.current.fitBounds(bounds, { padding: [15, 15] }); // padding opcional
    }
  };

  const renderMarkers = () => {


    if (trayectosSeleccionados.length > 0) {
      let newData = [];
      for (let index = 0; index < trayectosSeleccionados.length; index++) {
        const id_trayecto = trayectosSeleccionados[index];
        const finded = filteredShipments.find(item => item.id === id_trayecto);
        if (finded) {
          newData.push(finded);
        }
      }

      const validShipments = newData.filter(shipment => +shipment.last_latitude !== 0);
      return validShipments.map((shipment, idx) => {



        const punto = { "lat": shipment.last_latitude, "lng": shipment.last_longitude };
        // punto.lat, punto.lng
        return (
          <CustomMarker
            key={shipment.id}
            shipment={shipment}
            punto={punto}
            isSelected={popupAbiertoIdx === idx}
          />
        );
      });

    } else {
      const validShipments = shipments.filter(shipment => +shipment.last_latitude !== 0);
      return validShipments.map((shipment, idx) => {

        const punto = { "lat": shipment.last_latitude, "lng": shipment.last_longitude };
        // punto.lat, punto.lng
        return (
          <CustomMarker
            key={idx}
            shipment={shipment}
            punto={punto}
            isSelected={popupAbiertoIdx === idx}
          />
        );
      });
    }
  };



  // Function handlers

  const handleSelectAllChange = () => {
    if (allSelected) {
      // Deseleccionar todos
      setTrayectosSeleccionados([]);
    } else {
      // Seleccionar todos
      setGeometrySelected([]);
      setLocationSelected([]);
      const todosIds = filteredShipments.map(s => s.id);
      setTrayectosSeleccionados(todosIds);

      const allPoints = filteredShipments
        .filter(s => {
          const included = todosIds.includes(s.id);
          const hasValidCoords = s.last_latitude !== 0 && s.last_longitude !== 0;
          return included && hasValidCoords;
        });

      if (mapRef.current && allPoints.length > 0) {
        const bounds = L.latLngBounds(allPoints.map(p => [p.last_latitude, p.last_longitude]));
        mapRef.current.fitBounds(bounds, {
          padding: [50, 50],
          maxZoom: 15,
        });
      }


    }
  };



  const allSelected =
    filteredShipments.length > 0 &&
    filteredShipments.every(s => trayectosSeleccionados.includes(s.id));




  const clearTracking = () => {
    setTrayectosSeleccionados([]);
    desconectarWebSocketGeocercaShipment();
    clearAllFeatures();

    setGeometrySelected([]);
    setLocationSelected([]);
  };

  // Function to get status badge with color coding
  const getStatusBadge = (status) => {
    const normalizedStatus = status?.toUpperCase().replace(' ', '_');

    const styles = {
      PENDIENTE: 'bg-yellow-100 text-yellow-800 border-yellow-300',
      EN_CLIENTE: 'bg-indigo-500 text-white border-indigo-600',
      ENTREGADO: 'bg-green-100 text-green-800 border-green-300',
      CANCELADO: 'bg-red-100 text-red-800 border-red-300',
      ARRIBADO: 'bg-sky-600 text-white border-sky-700',
      TRANSITO: 'bg-green-500 text-white border-green-600',
      FINALIZADO: 'bg-green-700 text-white border-green-800',
      CREADO: 'bg-gray-100 text-gray-800 border-gray-300',
    };

    const statusClass = styles[normalizedStatus] || 'bg-gray-100 text-gray-800 border-gray-300';

    return (
      <span className={`px-2 py-1 rounded-full text-sm font-medium border ${statusClass}`}>
        {status || 'N/A'}
      </span>
    );
  };

  // Format date for better display
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';

    const date = new Date(dateString);
    return date.toLocaleString('es-ES', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    });
  };

  // Extract delivery date from orders
  const getDeliveryDate = (shipment) => {
    if (!shipment.orders || shipment.orders.length === 0) {
      return 'Sin fecha de entrega';
    }

    // Find the earliest appointment date among the orders
    const dates = shipment.orders
      .filter(order => order.Appointment)
      .map(order => {
        const dateStr = order.Appointment;
        const timeStr = order.Appointment_hr || '00:00';

        // Parse date and time
        const [year, month, day] = dateStr.split('-').map(Number);
        const [hours, minutes] = timeStr.split(':').map(Number);

        return new Date(year, month - 1, day, hours, minutes);
      });

    if (dates.length === 0) return 'Sin fecha de entrega';

    // Return the earliest date
    const earliestDate = new Date(Math.min(...dates));
    return formatDate(earliestDate);
  };

  function getDistanceMeters(lat1, lon1, lat2, lon2) {
    const R = 6371e3; // radio Tierra en metros
    const toRad = deg => deg * Math.PI / 180;

    const φ1 = toRad(lat1), φ2 = toRad(lat2);
    const Δφ = toRad(lat2 - lat1);
    const Δλ = toRad(lon2 - lon1);

    const a = Math.sin(Δφ / 2) ** 2 +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }


  const fetchShipments2 = async () => {
    try {
      const responseCuentas = await TransportistasService.getCuentas();
      if (responseCuentas.status == 200 && responseCuentas.data) {
        setCuentas(responseCuentas.data)
      }

      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/get-active-shipments`);
      const processedShipments = response.data;
      console.log("GET_SHIPMENT");

      const newOptionsReference = processedShipments.map(ship => ship.reference);
      setOptionsReference(newOptionsReference)

      const newOptionsTruck = processedShipments.map(ship => ship.Truck);
      setOptionsTruck(newOptionsTruck)

      const newOptionsStatus = processedShipments.map(ship => ship.status);
      setOptionsStatus(newOptionsStatus)

      const newOptionsSubtatus = processedShipments.map(ship => ship.Substatus);
      setOptionsSubtatus(newOptionsSubtatus)


      const whatItemisOnline = processedShipments.map(ship => {
        let isInactive = false;
        let isStationary = false;

        // Verificar inactividad por timestamp (> 1 minuto sin actualización)
        if (ship.last_activity) {
          const diff = (Date.now() - new Date(ship.last_activity)) / 60000;
          isInactive = diff > 1;
        } 

        // Verificar si llegó una ubicación reciente pero sin moverse
        if (
          ship.last_timestamp &&
          (Date.now() - new Date(ship.last_timestamp)) / 60000 > 2
        ) {
          isStationary = true; // Si han pasado más de 2 minutos desde la última ubicación, se considera detenido
        } else if (
          ship.last_latitude != null &&
          ship.last_longitude != null &&
          ship.prev_latitude != null &&
          ship.prev_longitude != null
        ) {
          const dist = getDistanceMeters(
            ship.last_latitude,
            ship.last_longitude,
            ship.prev_latitude,
            ship.prev_longitude
          );
          isStationary = dist < 8; // Umbral de 8 metros
        }

        return {
          ...ship,
          isInactive,
          isStationary
        };
      });



      debugger


      const newInactive = whatItemisOnline.filter(ship =>
        ship.isInactive
      );

      if (newInactive.length > 0) {
        toast.current.show({
          key: 'inactive-alert',
          severity: 'error',
          summary: 'Aviso',
          detail: `Hay ${newInactive.length} viaje(s) inactivo(s)`,
          life: 29100
        });

      }




      setShipments(whatItemisOnline);

      setSelectedShipments({});
      setSelectAll(false);

      conectarWebSocketShipmentLastUbication()
      setIsLoadingPage(false)

    } catch (error) {
      console.error('Error fetching active shipments:', error);
      setIsLoadingPage(false)
    }
  };




  useEffect(() => {

    // Ejecuta una vez al montar
    fetchShipments2();


    // Configura el intervalo para actualizar cada 30 segundos
    const interval = setInterval(fetchShipments2, 30000);

    // Limpia el intervalo cuando el componente se desmonte
    return () => {
      clearInterval(interval);
      desconectarWebSocketShipmentLastUbication(); // <-- muy importante
    };
  }, []);

  const conectarWebSocketShipmentLastUbication = () => {
    if (wsShipmentLastUbication.current &&
      (wsShipmentLastUbication.current.readyState === WebSocket.OPEN ||
        wsShipmentLastUbication.current.readyState === WebSocket.CONNECTING)) {
      // Ya está conectado o conectándose
      return;
    }

    const roomId = `salaShipmentLastUbication`;
    const ws = new WebSocket(`${process.env.REACT_APP_WEB_SOCKET_URL}/${roomId}`);

    ws.onopen = () => {
      console.log(`Conectado a la sala: ${roomId}`);
    };

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log("Mensaje recibido:", data);

      if (data.action === "update_last_ubication") {
        let id_shipment = data.id_shipment
        setShipments(prev => {
          const updated = prev.map(shipment => {
            if (shipment.id === id_shipment) {
              return {
                ...shipment,
                last_latitude: data.data.latitude,
                last_longitude: data.data.longitude,
              };
            }
            return shipment;
          });

          // setFilteredShipments(prevFiltered =>
          //   prevFiltered.map(shipment => {
          //     if (shipment.id === id_shipment) {
          //       return {
          //         ...shipment,
          //         last_latitude: data.data.latitude,
          //         last_longitude: data.data.longitude,
          //       };
          //     }
          //     return shipment;
          //   })
          // );

          return updated;
        });


      }
      // Procesa la geocerca actualizada
    };

    ws.onerror = (error) => console.error("WebSocket error:", error);

    ws.onclose = (ev) => {
      console.log(`Desconectado de ${roomId}`, ev.reason);
    };

    wsShipmentLastUbication.current = ws;  // <-- Muy importante asignar aquí
  };

  const desconectarWebSocketShipmentLastUbication = () => {
    if (wsShipmentLastUbication.current) {
      wsShipmentLastUbication.current.close();
      wsShipmentLastUbication.current = null;  // <-- limpiar referencia
    }
  };




  // Filter handlers
  const handleFilter = () => {
    if (!startDate || !endDate) {
      alert('Please select both start and end dates');
      return;
    }

    const start = new Date(startDate);
    const end = new Date(endDate);

    const filtered = shipments.filter(shipment => {
      if (!shipment.pickup_date) return false;
      const shipmentDate = new Date(shipment.pickup_date);
      return shipmentDate >= start && shipmentDate <= end;
    });

    // setFilteredShipments(filtered);

    // Reset selections when filter changes
    setSelectedShipments({});
    setSelectAll(false);
  };

  const handleClearFilter = () => {
    setStartDate('');
    setEndDate('');
    // setFilteredShipments(shipments);

    // Reset selections when filter is cleared
    setSelectedShipments({});
    setSelectAll(false);
  };


  // CREATE: Manejar creación de nuevas formas
  const _onCreated = (e) => {
    const { layerType, layer } = e;

    setPendingLayer({ layerType, layer });
    setOpenDialog(true);
  };


  const handleConfirm = async (featureName) => {
    const { layerType, layer } = pendingLayer;
    const geojson = layer.toGeoJSON();

    console.log(trayectosSeleccionados);


    geojson.properties = {
      ...geojson.properties,
      type: layerType,
      name: featureName,
    };

    if (layerType === 'circle') {
      geojson.properties.radius = layer.getRadius();
    }


    const newFeature = {
      type: layerType,
      name: featureName,
      geojson,
      id_shipment: trayectosSeleccionados[0]
    };


    try {
      const response = await GeocercasService.createGeocerca(newFeature);

      if (response.data.status && response.data.status == 200) {
        const apiData = response.data.data;
        const nuevaGeocerca = response.data.data.geojson;


        // Eliminar la capa provisional dibujada por DrawControl
        featureGroupRef.current.removeLayer(layer);



        // Actualizar el estado con la nueva geocerca
        setFeaturesGeofences((prev) => [...prev, nuevaGeocerca]);

        // Restablecer los estados del formulario
        setPendingLayer(null);
        // setFeatureName('');
        setOpenDialog(false);

      } else {
        const { msg } = response.data;
        toast.current.show({ severity: 'error', summary: 'Error', detail: msg, life: 3000 });
        // toast.error("Ocurrió un error: " + msg);
      }

    } catch (error) {
      console.error('Error al crear la geocerca:', error);
      toast.current.show({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
      // toast.error("Ocurrió un error: " + error.message);
    }

  };


  const handleCancel = () => {
    const { layer } = pendingLayer;
    featureGroupRef.current.removeLayer(layer);
    setPendingLayer(null);
    // setFeatureName('');
    setOpenDialog(false);
  };




  // Editar características existentes
  const _onEdited = async (e) => {

    const layers = e.layers;
    const updatedFeatures = [];

    layers.eachLayer((layer) => {
      const editedGeoJSON = layer.toGeoJSON();


      const id = layer.feature?.properties?.id_geocercas || editedGeoJSON.properties?.id_geocercas;
      // const originalType = layer.feature?.properties?.type;

      if (!id) return;

      // Construir el payload para el backend
      let id_shipment = trayectosSeleccionados[0];

      updatedFeatures.push({
        id_geocercas: id,
        id_shipment: id_shipment,
        geojson: editedGeoJSON
      });


    });

    if (updatedFeatures.length === 0) return;

    try {
      //Enviar cada edición al backend (puedes paralelizar o agrupar)
      await Promise.all(
        updatedFeatures.map(({ id_geocercas, id_shipment, geojson }) =>
          GeocercasService.updateGeocerca(id_geocercas, id_shipment, { geojson })
        )
      );

    } catch (err) {
      console.error('Error al actualizar geocercas:', err);
    }

  };






  // Eliminar características
  const _onDeleted = async (e) => {
    const layers = e.layers;
    const deletedIds = [];

    layers.eachLayer((layer) => {
      const id = layer.feature?.properties?.id_geocercas;
      if (id) deletedIds.push(id);
    });

    if (deletedIds.length === 0) return;

    try {
      let id_shipment = trayectosSeleccionados[0];

      await Promise.all(
        deletedIds.map((id) => GeocercasService.deleteGeocerca(id, id_shipment))
      );

      // Opcional: Actualizar el estado local si es necesario
      // setFeatures((prev) => prev.filter(f => !deletedIds.includes(f.properties.id_geocercas)));

      console.log('Geocercas eliminadas correctamente.');
    } catch (err) {
      console.error('Error al eliminar geocercas:', err);
    }
  };


  const clearAllFeatures = () => {
    if (featureGroupRef.current) {
      featureGroupRef.current.clearLayers();
    }
    setFeaturesGeofences([]);
  };

  const options = [
    { title: 'Opción 1', id: 1 },
    { title: 'Opción 2', id: 2 },
    { title: 'Opción 3', id: 3 },
    { title: 'Opción 4', id: 4 },
  ];

  function formatISODate(iso) {
    const d = new Date(iso);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }


  const [selectedOptions, setSelectedOptions] = useState([]);

  const showPositions = geometrySelected.map(punto => [punto.latitude, punto.longitude]);
  const showLocations = locationSelected;

  const editControl = useMemo(() => (
    trayectosSeleccionados.length === 1 ? (
      <EditControl
        position="topleft"
        onCreated={_onCreated}
        onEdited={_onEdited}
        onDeleted={_onDeleted}
        draw={{
          rectangle: true,
          circle: true,
          circlemarker: false,
          marker: false,
          polyline: false,
          polygon: true,
        }}
        edit={{
          edit: false,
          remove: true,
          featureGroup: featureGroupRef.current,
        }}
      />
    ) : null
  ), [trayectosSeleccionados.length]);

  function createClusterCustomIcon(cluster) {
    const children = cluster.getAllChildMarkers();

    const hasInactive = children.some(m => m.options.options.isInactive); // suponiendo que defines isInactive en cada marker

    const count = cluster.getChildCount();
    const size = count < 10 ? 'small' : count < 100 ? 'medium' : 'large';

    return L.divIcon({
      html: `<div><span>${count}</span></div>`,
      className: `marker-cluster marker-cluster-${size} ${hasInactive ? 'has-inactive' : 'all-active'}`,
      iconSize: L.point(40, 40),
    });
  }


  const sendNotificationToPhone = async (shipment) => {

    setSendingNotification(true);
    let data = {
      id_operador: shipment.id_driver
    }

    const response = await NotificationPhoneService.postSendNotification(data);
    if (response.data.status && response.data.status == 200) {
      toastTopCenter.current.show({ severity: 'success', summary: 'Aviso', detail: `Notificacion enviada` });
    }
    setSendingNotification(false);

  };

  return (
    <div className="flex">
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={isLoadingPage}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Toast ref={toast} />
      <Toast ref={toastTopCenter} position="top-center" />

      <Sidebar
        isOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
      />


      <div className={`transition-all duration-300 flex-1 ${sidebarOpen ? 'ml-64' : 'ml-16'} bg-gray-100 min-h-screen p-6 relative`}>
        <Topbar
          title="Torre de Control"
          showSearch={false}
          rightContent={
            <div className="flex space-x-4">


            </div>
          }
        />

        {/* Status summary cards */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mt-6">

          <div className="bg-white p-4 rounded-lg shadow flex items-center justify-between">

            <div>
              <h3 className="text-sm font-medium text-gray-500">Total Embarques</h3>
              <p className="text-2xl font-bold">{filteredShipments.length}</p>
            </div>
            <Package className="h-8 w-8 text-blue-500" />
          </div>

          <div className="bg-white p-4 rounded-lg shadow flex items-center justify-between">
            <div>
              <h3 className="text-sm font-medium text-gray-500">Pendientes</h3>
              <p className="text-2xl font-bold">{filteredShipments.filter(s => ['PENDIENTE', 'CREADO'].includes(s.status)).length}</p>
            </div>
            <Clock className="h-8 w-8 text-yellow-500" />
          </div>


          <div className="bg-white p-4 rounded-lg shadow flex items-center justify-between">
            <div>
              <h3 className="text-sm font-medium text-gray-500">Arribado</h3>
              <p className="text-2xl font-bold">{filteredShipments.filter(s => ['ARRIBADO'].includes(s.status)).length}</p>
            </div>
            <Warehouse className="h-8 w-8 text-orange-500" />
          </div>

          <div className="bg-white p-4 rounded-lg shadow flex items-center justify-between">
            <div>
              <h3 className="text-sm font-medium text-gray-500">En Tránsito</h3>
              <p className="text-2xl font-bold">{filteredShipments.filter(s => ['TRANSITO', 'RESGUARDO'].includes(s.status)).length}</p>
            </div>
            <Truck className="h-8 w-8 text-green-500" />
          </div>

          <div className="bg-white p-4 rounded-lg shadow flex items-center justify-between">
            <div>
              <h3 className="text-sm font-medium text-gray-500">En Cliente</h3>
              <p className="text-2xl font-bold">{filteredShipments.filter(s => s.status === 'EN CLIENTE').length}</p>
            </div>
            <MapPin className="h-8 w-8 text-indigo-500" />
          </div>


        </div>

        {/* Tracking Control Bar */}
        <div className="bg-white p-4 rounded-lg shadow mt-6 ">

          <div className="grid grid-cols-1 md:grid-cols-5 gap-4 ">
            <div>
              <Autocomplete
                disablePortal
                options={optionsReference}

                renderInput={(params) => <TextField {...params} label="Referencia" className='borderFilters paddingMUISelect' />}
                onChange={(event, newValue) => {
                  setFilters({ ...filters, reference: newValue || "" });
                }}
              />
            </div>

            <div><Autocomplete
              disablePortal
              options={optionsTruck}

              renderInput={(params) => <TextField {...params} label="Truck" className='borderFilters paddingMUISelect' />}
              onChange={(event, newValue) => {

                setFilters({ ...filters, truck: newValue || "" });
              }}
            /></div>

            <div >
              <MultiSelect value={filters.status} onChange={(e) => { setFilters({ ...filters, status: e.value || "" }) }} options={[...new Set([...optionsStatus])]}

                filter placeholder="Estatus" maxSelectedLabels={1} className="w-full md:w-20rem borderFilters" showClear={true}
              />
            </div>

            <div >
              <MultiSelect value={filters.substatus} onChange={(e) => { setFilters({ ...filters, substatus: e.value || "" }) }} options={[...new Set([...optionsSubStatus])]}
                filter placeholder="SubEstatus" maxSelectedLabels={1} className="w-full md:w-20rem borderFilters" showClear={true} />
            </div>

            <div ><button
              onClick={clearTracking}
              disabled={trayectosSeleccionados.length === 0}
              className={`flex items-center px-4 py-3 rounded w-full ${trayectosSeleccionados.length > 0
                ? 'bg-red-500 text-white hover:bg-red-600'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                }`}
            >
              Limpiar Seguimiento
            </button></div>

            <div className="flex justify-content-center borderFilters  px-2 ">
              <FloatLabel className={dates?.length ? 'mx-0 px-0 mt-4' : ''}>
                <CalendarPrime
                  inputId="dates"
                  value={dates}
                  onChange={(e) => {
                    const [from, to] = e.value || []; // Desestructura el rango
                    setDates(e.value);
                    setFilters(prev => ({
                      ...prev,
                      pickupDate: {
                        from: from || "",
                        to: to || ""
                      }
                    }));
                  }}
                  selectionMode="range"
                  dateFormat="dd/mm/yy"
                  readOnlyInput
                  hideOnRangeSelection
                  showButtonBar
                  locale="es"
                />
                <label htmlFor="dates">Fecha de carga</label>
              </FloatLabel>
            </div>

            <div className="flex justify-content-center borderFilters  px-2 ">
              <FloatLabel className={dates2?.length ? 'mx-0 px-0 mt-4' : ''}>
                <CalendarPrime
                  inputId="dates2"
                  value={dates2}
                  onChange={(e) => {
                    const [from, to] = e.value || []; // Desestructura el rango
                    setDates2(e.value);
                    setFilters(prev => ({
                      ...prev,
                      orderAppointmentDate: {
                        from: from || "",
                        to: to || ""
                      }
                    }));
                  }}
                  selectionMode="range"
                  dateFormat="dd/mm/yy"
                  readOnlyInput
                  hideOnRangeSelection
                  showButtonBar
                  locale="es"
                />
                <label htmlFor="dates2">Fechas de entrega</label>
              </FloatLabel>
            </div>

            <div style={{ borderColor: "#e5e7eb" }}>
              <MultiSelect style={{ borderColor: "#e5e7eb" }} value={filters.vendor} onChange={(e) => {

                setFilters({ ...filters, vendor: e.value || "" })
              }

              }
                options={cuentas}
                filter placeholder="Cliente" maxSelectedLabels={1} className="w-full md:w-20rem borderFilters" optionLabel='nombre_cuenta' showClear={true} />
            </div>


          </div>
        </div>

        {activeTracking.length > 0 && (
          <div className="bg-yellow-50 border border-yellow-200 p-3 rounded-lg mt-3">
            <div className="flex items-center text-yellow-800">
              <Truck className="h-5 w-5 mr-2" />
              <span className="font-semibold">Seguimiento activo:</span>
              <span className="ml-2">{activeTracking.length} embarques</span>
            </div>
          </div>
        )}

        <div className="flex mt-6">
          <div className="w-1/4 p-4 bg-white rounded-lg shadow-md mr-4 max-h-[70vh] overflow-y-auto">
            <h2 className="text-lg font-semibold mb-4">Embarques Activos</h2>
            <ul className="space-y-4">
              <div className="flex items-center">
                <label className="flex items-center space-x-2 cursor-pointer mr-4">
                  <input
                    type="checkbox"
                    className="form-checkbox h-5 w-5 text-blue-600 rounded"
                    checked={allSelected}
                    onChange={handleSelectAllChange}
                  />
                  <span>Seleccionar Todos</span>
                </label>

              </div>
              {filteredShipments && filteredShipments.length > 0 ? (
                filteredShipments.map((shipment, index) => (
                  <li
                    key={shipment.id}
                    className={`p-4 hover:bg-gray-50 border ${shipment.isInactive ? "glowing-border" : ""}  rounded-lg cursor-pointer transition-all relative `}
                  >
                    <div className="flex items-start ">
                      <input
                        type="checkbox"
                        className="form-checkbox h-5 w-5 mt-1 text-blue-600 rounded"
                        checked={isChecked(shipment.id)}
                        onChange={(e) => handleClickSelectedTrayecto(shipment)}
                        onClick={(e) => e.stopPropagation()}
                      />
                      <div
                        className="flex-1 ml-3"
                        onClick={() => {
                          // Center map on this shipment when clicked
                          if (shipment.latitude && shipment.longitude) {
                            setMapCenter([shipment.latitude, shipment.longitude]);
                          }
                        }}
                      >
                        <div className="flex justify-between items-center mb-2">
                          <h3 className="font-bold text-lg">{shipment.reference || 'Sin referencia'}</h3>
                          {getStatusBadge(shipment.status)}
                        </div>

                        {/* <div className="flex items-center text-sm text-gray-600 mb-1">
                          <User className="h-4 w-4 mr-2" />
                          <span>Cliente: {shipment.customer || 'N/A'}</span>
                        </div> */}

                        {/* <div className="flex items-center text-sm text-gray-600 mb-1">
                          <MapPin className="h-4 w-4 mr-2" />
                          <span>Destino: {shipment.destination || 'N/A'}</span>
                        </div> */}

                        {/* <div className="flex items-center text-sm text-gray-600">
                          <Calendar className="h-4 w-4 mr-2" />
                          <span>Carga: {formatDate(shipment.pickup_date)}</span>
                        </div> */}

                        {/* <div className="flex items-center text-sm text-gray-600 mt-1">
                          <Clock className="h-4 w-4 mr-2" />
                          <span>Entrega: {getDeliveryDate(shipment)}</span>
                        </div> */}

                        <div className="flex items-center text-sm text-gray-600">
                          <IdCard className="h-4 w-4 mr-2" />
                          <span className="capitalize">Operador: {shipment.driver && shipment.driver.toLowerCase()}</span>
                          <span className="capitalize ml-1"> {!shipment.driver && (<>Pendiente</>)}</span>
                        </div>

                        {/* <div className="flex items-center text-sm text-gray-600">
                          <RectangleHorizontal className="h-4 w-4 mr-2" />
                          <span>Placas: {shipment.vehicle && shipment.vehicle}</span>
                          <span className="capitalize ml-1"> {!shipment.vehicle && (<>Pendiente</> )}</span>
                        </div> */}

                        <div className="flex items-center text-sm text-gray-600">
                          <Truck className="h-4 w-4 mr-2" />
                          <span>Truck: {shipment.Truck && shipment.Truck}</span>
                          <span className="capitalize ml-1"> {!shipment.Truck && (<>Pendiente</>)}</span>
                        </div>

                        {shipment.Substatus && (
                          <div className="mt-2 text-xs bg-gray-100 rounded p-1 text-gray-700 inline-block">
                            {shipment.Substatus}
                          </div>
                        )}

                        {/* Incident button placed at the bottom right of each shipment card */}

                        <div className='flex flex-row'>

                          <div>
                            <button
                              onClick={(e) => {
                                e.stopPropagation(); // Prevent the shipment card click event
                                sendNotificationToPhone(shipment);
                              }}
                              disabled={sendingNotification}
                              className="absolute bottom-2 left-2 bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center shadow-md hover:bg-blue-600 transition-colors"
                              title="Enviar notificacion"
                            >
                              <MessageSquarePlus className="h-4 w-4" />
                            </button>
                          </div>

                          <div>
                            <button
                              onClick={(e) => {
                                e.stopPropagation(); // Prevent the shipment card click event
                                handleOpenIncidentModal(shipment);
                              }}
                              className="absolute bottom-2 right-2 bg-red-500 text-white rounded-full w-8 h-8 flex items-center justify-center shadow-md hover:bg-red-600 transition-colors"
                              title="Registrar Incidencia"
                            >
                              <AlertTriangle className="h-4 w-4" />
                            </button>
                          </div>

                        </div>


                      </div>
                    </div>
                  </li>
                ))
              ) : (
                <li className="text-gray-500 p-4 text-center border rounded">No se encontraron embarques</li>
              )}
            </ul>
          </div>

          <div className="w-3/4 h-[70vh] bg-white rounded-lg shadow-md overflow-hidden" style={{ position: 'relative', zIndex: 1 }}>


            <div style={{ height: '100vh', width: '100%', position: 'relative' }}>
              <MapContainer
                MapContainer center={[20.661, -103.352]} zoom={5} style={{ height: '100vh', width: '100%' }}
                ref={mapRef}
                whenCreated={(map) => {
                  mapRef.current = map;
                  // Forzar actualización del mapa después de cargar
                  setTimeout(() => map.invalidateSize(), 0);
                }}
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'

                />

                <FeatureGroup ref={featureGroupRef}>

                  {/* {trayectosSeleccionados.length == 1 && (

                    <EditControl
                      position="topleft"
                      onCreated={_onCreated}
                      onEdited={_onEdited}
                      onDeleted={_onDeleted}
                      draw={{
                        rectangle: true,
                        circle: true,
                        circlemarker: false,
                        marker: false,
                        polyline: false,
                        polygon: true,
                      }}
                      edit={{
                        edit: true,
                        remove: true,
                        featureGroup: featureGroupRef.current,
                      }}
                    />
                  )} */}
                  {editControl}

                </FeatureGroup>

                <Polyline positions={showPositions} pathOptions={{ color: 'blue', weight: 4 }} />

                {showLocations
                  .filter((_, idx) => idx % 10 === 0)
                  .map((item, filteredIdx) => {
                    const idxOriginal = filteredIdx * 10; // índice original (0, 10, 20, ...)
                    const { latitude: lat, longitude: lng, location_timestamp, battery_level, speed } = item;
                    return (
                      <Circle
                        key={idxOriginal}
                        center={[lat, lng]}
                        pathOptions={{ color: 'red', weight: 8 }}
                        radius={2}
                      >
                        <Popup>
                          Posición {idxOriginal}:<br />
                          Lat: {lat.toFixed(6)},<br />
                          Lng: {lng.toFixed(6)}<br />
                          {formatISODate(location_timestamp)} <br />
                          batería: {battery_level} <br />
                          velocidad: {speed.toFixed(2)}
                        </Popup>
                      </Circle>
                    );
                  })}




                <MarkerClusterGroup iconCreateFunction={createClusterCustomIcon}>
                  {renderMarkers()}
                </MarkerClusterGroup>
              </MapContainer>


              <FeatureDialog
                openDialog={openDialog}
                handleCancel={handleCancel}
                handleConfirm={handleConfirm}
              />



              {/* Panel de control */}

              {trayectosSeleccionados.length == 1 && (

                <div className='absolute top-[10px] right-[10px] z-[1000] bg-white p-2 rounded shadow-md'>
                  {/* <h4>Formas guardadas: {featuresGeofences.length}</h4> */}
                  {/* <button onClick={clearAllFeatures}>Limpiar Todo</button> */}
                  <Autocomplete
                    sx={{ width: 250 }}
                    multiple
                    options={featuresGeofences}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.name}
                    isOptionEqualToValue={(option, value) => option.name === value.name} // 👈 necesario en objetos
                    value={selectedOptions}
                    onChange={(event, newValue) => setSelectedOptions(newValue)}
                    renderTags={(value, getTagProps) => {
                      if (value.length === 0) return null;

                      const first = value[0].name;
                      const extraCount = value.length - 1;
                      const label = extraCount > 0 ? `${first} +${extraCount} más` : first;

                      return [
                        <span
                          key="tag"
                          className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-sm"
                        >
                          {label}
                        </span>
                      ];
                    }}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.name}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField {...params} label="Selecciona las geocercas disponibles" placeholder="Opciones" />
                    )}
                  />
                </div>
              )}
            </div>


          </div>
        </div>

      </div>

      {/* Modal container with highest z-index */}
      {isIncidentModalOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
          style={{ zIndex: 9999 }}
        >
          <div onClick={e => e.stopPropagation()}>
            <ModalIncidencias
              onClose={handleCloseIncidentModal}
              shipmentReference={selectedShipmentForIncident?.reference || ''}
            />
          </div>
        </div>
      )}

      {/* Add custom styles for tracked markers */}
      <style jsx global>{`
        .pulse-marker {
          animation: pulse 1.5s infinite;
        }
        
        @keyframes pulse {
          0% {
            opacity: 1;
          }
          50% {
            opacity: 0.6;
          }
          100% {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default ActiveShipments;
